import Typography from '@mui/material/Typography';
import QButton from 'components/QButton';
import PropTypes from 'prop-types';
import React from 'react';
import ShortcutsSelect from './ShortcutsSelect';
import useStyles from './styles';

function CustomActionbar(props) {
  const { shortcutItems, selectedDefaultId, handleAccept, handleClose, handleDefaultSelect, isValidRange } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.actionSection}>
      {shortcutItems && selectedDefaultId ? (
        <div className={classes.defaultSection}>
          <Typography display={'block'}>Default to show</Typography>

          <ShortcutsSelect
            shortcutItems={shortcutItems}
            selectedId={selectedDefaultId}
            handleSelect={handleDefaultSelect}
          />
        </div>
      ) : (
        <div className={classes.defaultSection} />
      )}

      <div className={classes.buttonSection}>
        <QButton variant='outlined' id='cancel-date-range' className={classes.actionButtons} onClick={handleClose}>
          Cancel
        </QButton>
        <QButton
          variant='contained'
          id='apply-date-range'
          className={classes.actionButtons}
          onClick={handleAccept}
          disabled={!isValidRange}
        >
          Apply Dates
        </QButton>
      </div>
    </div>
  );
}

CustomActionbar.propTypes = {
  shortcutItems: PropTypes.array,
  selectedDefaultId: PropTypes.string,
  handleAccept: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDefaultSelect: PropTypes.func.isRequired,
  isValidRange: PropTypes.bool.isRequired,
};

export default CustomActionbar;
